export enum WriterLengthEnum {
  Short = 'short',
  Medium = 'medium',
  Long = 'long'
}
